export default {
  toastTimeoutTitle: {
    id: 'buyback_quotes_timeout_toast_title',
    defaultMessage: 'Loading... this could take a sec',
  },
  toastTimeoutContent: {
    id: 'buyback_quotes_timeout_toast_content',
    defaultMessage: 'Refresh the page to view prices faster.',
  },
}
